import { servicePayments } from "../servicePayments";

export const deleteRequirementDefinition = async (
  id: string
): Promise<void> => {
  const response = await servicePayments.delete(
    `/requirement-definition/${id}`
  );
  return response.data;
};
